/* OKKO B2B — cart drawer: pannello laterale del carrello VERO (non della bozza).
 * Si apre dal carrello in testata (il link /cart resta il fallback senza JS).
 * Le righe vengono dal builder condiviso window.OKKO.ui (stesso markup delle
 * modali Riepilogo/Ordine Rapido/Salvati); le quantita' parlano con /cart/change.js
 * e ogni risposta aggiorna anche la pill del totale via window.OKKO.updateCartCount.
 * Testi da window.OKKO.testi (locales) con fallback. */
(() => {
  'use strict';

  const T = (window.OKKO && window.OKKO.testi) || {};

  let dialog = null;

  // Form del checkout PERSISTENTE attraverso i re-render del drawer. Il CSS di
  // BSS spegne (pointer-events:none) ogni bottone checkout finche' il suo
  // script non lo aggancia e riabilita con stile INLINE sul nodo: ricreare il
  // bottone a ogni render lo lasciava morto ~1-2s (click a vuoto, visto da
  // Nicolas). Stesso nodo riattaccato = aggancio e riabilitazione sopravvivono.
  let checkoutForm = null;
  function ensureCheckoutForm() {
    if (checkoutForm) return checkoutForm;
    checkoutForm = document.createElement('form');
    checkoutForm.action = '/cart';
    checkoutForm.method = 'post';
    checkoutForm.style.display = 'contents';
    checkoutForm.innerHTML = `<button type="submit" name="checkout" class="okko-btn">${T.checkout || 'Vai al checkout'}</button>`;
    return checkoutForm;
  }

  // BSS spegne i bottoni checkout via CSS e li riabilita con stile inline, ma
  // SOLO alla fine del suo ciclo di ricalcolo: su un drawer aperto senza aver
  // toccato il carrello quel ciclo non parte mai e il bottone resta morto per
  // sempre (visto da Nicolas: aggancio fatto, inline mai arrivato). Appena il
  // bottone risulta AGGANCIATO (attributo trigger-added) lo riabilitiamo noi,
  // con lo stesso identico stile che userebbe lui: il click resta intercettato
  // dal suo handler, lo sconto non si bypassa. Se poi un suo ricalcolo lo
  // ri-spegne, la sua riabilitazione di fine ciclo funziona come sempre.
  function sbloccaQuandoAgganciato(btn) {
    if (btn.dataset.okkoSblocco) return;
    btn.dataset.okkoSblocco = '1';
    const t0 = Date.now();
    const timer = setInterval(() => {
      const agganciato = btn.getAttribute('bss-b2b-cart-trigger-added') === 'true';
      if (agganciato && !btn.style.pointerEvents) {
        btn.style.pointerEvents = 'unset';
        btn.style.cursor = 'pointer';
      }
      if ((agganciato && getComputedStyle(btn).pointerEvents !== 'none') || Date.now() - t0 > 8000) {
        clearInterval(timer);
        delete btn.dataset.okkoSblocco;
      }
    }, 200);
  }

  // Stato visivo del lock: mentre il bottone e' spento da BSS (aggancio in
  // corso o ricalcolo sconti) la label diventa "Calcolo prezzi…" (richiesta di
  // Nicolas): l'attesa si legge, e il click-replay raccoglie comunque i click.
  setInterval(() => {
    const btn = checkoutForm && checkoutForm.querySelector('button');
    if (!btn || !btn.isConnected || btn.classList.contains('okko-btn--spento')) return;
    const bloccato = getComputedStyle(btn).pointerEvents === 'none';
    const label = bloccato ? (T.calcoloPrezzi || 'Calcolo prezzi…') : (T.checkout || 'Vai al checkout');
    if (btn.textContent !== label) btn.textContent = label;
    btn.classList.toggle('okko-btn--attesa', bloccato);
  }, 250);

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'okko-drawer';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-okko-dr-close]')) dialog.close();
    });
    return dialog;
  }

  // /cart.js NON espone compare_at_price: la mappa variant_id -> listino arriva
  // dalla vista-sonda /cart?view=listini (stesso pattern di ?view=sku).
  let listini = {};
  async function caricaListini() {
    try { listini = await (await fetch('/cart?view=listini')).json(); }
    catch { listini = {}; }
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=120';
  }

  // Sconto BSS (SOLO display). Carrello e drawer mostrano i prezzi Shopify PIENI
  // (/cart.js e' la verita' del checkout, che BSS sconta lato server in cassa).
  // Per coerenza con la vetrina si applica lo STESSO sconto del ponte
  // (window.OKKO.bss) solo alla RESA: unitario barrato, subtotali e totale. Il
  // carrello Shopify resta pieno; lo sconto reale lo mette BSS al checkout.
  // Ritorna una mappa key->{unit, base, line, scontato} + il totale scontato.
  // Se BSS assente/senza regole: mappa vuota e totale invariato (nessun effetto).
  async function scontaBss(cart) {
    const info = new Map();
    let total = cart.total_price;
    const bss = window.OKKO && window.OKKO.bss;
    if (!bss) return { info, total };
    const pids = [...new Set((cart.items || []).map((i) => i.product_id).filter(Boolean))];
    try { await Promise.all(pids.map((pid) => bss.assicuraProdotto(pid))); }
    catch (e) { return { info, total }; }
    total = 0;
    (cart.items || []).forEach((item) => {
      const d = bss.prezzoVariante(item.variant_id); // { p, op } o null
      const unit = d ? d.p : item.final_price;
      const line = unit * item.quantity;
      info.set(item.key, { unit, base: d ? d.op : null, line, scontato: !!d });
      total += line;
    });
    return { info, total, risparmio: risparmioBss(cart, info) };
  }

  // Risparmio VERO: somma di (prezzo pieno - prezzo pagato) x quantita', cioe'
  // esattamente i numeri che il drawer mostra gia' barrati riga per riga, e lo
  // stesso conto che fa il checkout ("Risparmi totali").
  //
  // PRIMA si usava cart.total_discount, che e' un'ALTRA cosa: lo sconto che
  // SHOPIFY ha applicato al carrello, non il risparmio rispetto al listino. I
  // due non possono coincidere, e su un carrello di prova il drawer diceva
  // 18,60 dove il checkout diceva 25,70. Non era un arrotondamento: fonte
  // sbagliata. Senza ponte BSS (o senza righe scontate) si ricade sul valore
  // di Shopify, che su un carrello senza prezzi personalizzati e' corretto.
  function risparmioBss(cart, info) {
    let r = 0;
    (cart.items || []).forEach((item) => {
      const d = info.get(item.key);
      if (!d || !d.scontato || d.base == null) return;
      const delta = d.base - d.unit;
      if (delta > 0) r += delta * item.quantity;
    });
    return r > 0 ? r : cart.total_discount;
  }

  async function render(cart) {
    const d = ensureDialog();
    const ui = window.OKKO.ui;
    const money = window.OKKO.money;
    const { info, total, risparmio: risparmioReale } = await scontaBss(cart);

    // Le note sopravvivono al re-render (stepper/rimozioni ricostruiscono tutto):
    // si preservano testo digitato e stato aperto/chiuso del details.
    const notePrima = d.querySelector('[data-okko-cart-note]');
    const noteStato = notePrima
      ? { valore: notePrima.value, aperta: notePrima.closest('details').open }
      : null;

    const rows = (cart.items || []).map((item) => {
      const b = info.get(item.key) || {};
      const unit = b.unit != null ? b.unit : item.final_price;
      const linea = b.line != null ? b.line : item.final_line_price;
      return ui.modalRow({
        attrs: `data-okko-dr-row="${item.key}"`,
        img: thumb(item.image),
        url: item.url,
        title: item.product_title,
        sku: item.sku,
        metaHtml: item.variant_title ? `<span class="okko-qo-tag">${item.variant_title}</span>` : '',
        // scontato: barrato pieno BSS (originale) -> netto; altrimenti compare_at (listino) come prima
        priceHtml: ui.prezzoCell(unit, listini[item.variant_id], b.scontato ? b.base : undefined),
        qtyHtml: ui.stepperHtml({ qtyAttr: 'okko-dr-qty', stepAttr: 'okko-dr-step', id: item.key, value: item.quantity, max: null, min: 0 }),
        subHtml: ui.subCell(linea),
        actionsHtml: `<button type="button" class="okko-draft-row__remove" data-okko-dr-remove="${item.key}" aria-label="${T.rimuoviSelezione || 'Rimuovi'}">${ui.TRASH_SVG}</button>`,
      });
    }).join('');

    // Impostazioni globali del drawer (gruppo "Carrello" in theme settings)
    const cfg = (window.OKKO && window.OKKO.carrello) || {};
    const svuota = cfg.svuota !== false && cart.item_count > 0
      ? `<button type="button" class="okko-btn okko-btn--ghost okko-btn--clear" data-okko-dr-svuota>${ui.TRASH_SVG} ${T.svuotaCarrello || 'Svuota carrello'}</button>`
      : '';
    const risparmio = cfg.risparmio !== false && risparmioReale > 0
      ? `<span class="okko-drawer__risparmio">${T.risparmi || 'Risparmi'} <strong>−${money(risparmioReale)}</strong></span>`
      : '';
    const vediCarrello = cfg.vediCarrello !== false
      ? `<a class="okko-btn okko-btn--ghost" href="/cart">${T.vediCarrello || 'Vedi carrello'}</a>`
      : '';
    // Valore al pubblico + ricarico, in FRASE discorsiva (scelta di Nicolas:
    // qui niente layout a pillola — il cliente deve capire che non e' quanto
    // paga lui e che il valore e' IVA inclusa). Sotto il totale. Listino dalla
    // sonda ?view=listini, prezzo EFFETTIVO (sconto BSS) come il totale.
    const righeListino = (cart.items || [])
      .filter((i) => listini[i.variant_id])
      .map((i) => {
        const b = info.get(i.key) || {};
        return { q: i.quantity, p: b.unit != null ? b.unit : i.final_price, c: listini[i.variant_id] };
      });
    const listinoTot = ui.listinoFraseHtml ? ui.listinoFraseHtml(righeListino) : '';

    // Barra soglie COMPLETA (spedizione gratuita / sconti a scaglioni), dai
    // blocchi della sezione header (embed JSON in testata): track con tacche ed
    // etichette. In testata resta solo il testo del prossimo step; qui c'e' lo
    // spazio per la barra vera. I valori li scrive aggiornaSoglie (okko-cart.js)
    // subito dopo il render.
    const soglieHtml = (() => {
      const embed = document.querySelector('[data-okko-soglie-dati]');
      if (!embed) return '';
      let dati;
      try { dati = JSON.parse(embed.textContent); } catch (e) { return ''; }
      if (!Array.isArray(dati) || !dati.length) return '';
      dati.sort((a, b) => a.s - b.s);
      const max = dati[dati.length - 1].s;
      const eschtml = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
      // dd.i = SVG dell'icona scelta sul blocco Soglia (markup generato dal
      // Liquid di testata, non input utente): dentro la tacca, SEMPRE visibile
      // (anche da non raggiunta); al suo posto la spunta non si disegna piu'.
      // Tacche EQUIDISTANTI (un segmento per soglia), non in proporzione
      // all'importo: con scaglioni sbilanciati (150/250/500/1000) le prime due
      // finivano appiccicate e le etichette si sovrapponevano.
      const tacche = dati.map((dd, i) => `<span class="okko-soglie__tacca${dd.i ? ' has-icona' : ''}" style="left:${((i + 1) * 100) / dati.length}%" data-okko-soglie-tacca="${dd.s}">${dd.i || ''}<span class="okko-soglie__eti"><span class="okko-soglie__eti-cifra">€${Math.round(dd.s / 100)}</span>${eschtml(dd.l)}</span></span>`).join('');
      return `
        <div class="okko-drawer__soglie" data-okko-soglie>
          <p class="okko-soglie__testo" aria-live="polite"><span class="okko-soglie__frase" data-okko-soglie-frase></span></p>
          <div class="okko-soglie__track" role="progressbar" aria-label="${T.soglieAvanzamento || 'Avanzamento verso i vantaggi'}" aria-valuemin="0" aria-valuemax="${Math.round(max / 100)}"><span class="okko-soglie__fill" data-okko-soglie-fill></span>${tacche}</div>
        </div>`;
    })();

    d.innerHTML = `
      <div class="okko-draft-modal__head">
        <h2 class="okko-draft-modal__title">${T.carrello || 'Carrello'} <small>${cart.item_count} ${cart.item_count === 1 ? (T.articolo || 'articolo') : (T.articoli || 'articoli')}</small></h2>
        <div class="okko-drawer__head-azioni">
          ${svuota}
          <button type="button" class="okko-draft-modal__close" data-okko-dr-close aria-label="Chiudi"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7"/></svg></button>
        </div>
      </div>
      ${soglieHtml}
      <div class="okko-draft-modal__body okko-drawer__body">
        ${rows || `<p class="okko-empty">${T.carrelloVuoto || 'Il carrello è vuoto.'}</p>`}
      </div>
      <div class="okko-drawer__foot">
        ${cfg.note !== false ? `<details class="okko-cart__note">
          <summary>${T.noteOrdine || "Note per l'ordine"}<span class="okko-select__chev" aria-hidden="true"></span></summary>
          <textarea data-okko-cart-note></textarea>
        </details>` : ''}
        ${risparmio}
        <div class="okko-cart__totale-riga okko-order-total">
          <span>${T.totale || 'Totale:'}</span>
          <span class="okko-cart__totale-val">
            <strong>${money(total)}</strong>
            <small class="okko-nota-iva">${T.ivaEscl || 'IVA escl.'}</small>
          </span>
        </div>
        <p class="okko-cart__tasse">${T.tasse || 'Tasse e spedizione calcolate al checkout'}</p>
        <div class="okko-drawer__azioni" data-okko-dr-azioni>
          ${vediCarrello}
        </div>
        ${listinoTot ? `<p class="okko-cart__listino">${listinoTot}</p>` : ''}
      </div>`;

    // barra soglie appena ricostruita: riempi testo/fill/tacche con l'ultimo totale
    if (window.OKKO && window.OKKO.aggiornaSoglie) window.OKKO.aggiornaSoglie();

    // il form checkout persistente rientra nel footer appena ricostruito
    const azioni = d.querySelector('[data-okko-dr-azioni]');
    const formCk = ensureCheckoutForm();
    const btnCk = formCk.querySelector('button');
    btnCk.classList.toggle('okko-btn--spento', cart.item_count === 0);
    azioni.prepend(formCk);
    sbloccaQuandoAgganciato(btnCk);

    const noteDopo = d.querySelector('[data-okko-cart-note]');
    if (noteDopo) {
      noteDopo.value = noteStato ? noteStato.valore : (cart.note || '');
      if (noteStato && noteStato.aperta) noteDopo.closest('details').open = true;
    }

    // Il drawer ricostruisce l'HTML a ogni render: il pulsante checkout e' un
    // nuovo nodo, non ancora agganciato dall'interceptor di BSS. Si forza la sua
    // ri-scansione (BSS marca i pulsanti con `bss-b2b-cart-trigger-added` e li
    // lega). Guardato: no-op se BSS non e' presente (tema senza app embed).
    try { window.BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.(); } catch (e) {}
  }

  async function refresh() {
    const [cart] = await Promise.all([
      fetch('/cart.js').then((r) => r.json()),
      caricaListini(), // in parallelo: il drawer si apre coi listini gia' pronti
    ]);
    await render(cart);
    if (window.OKKO.updateCartCount) window.OKKO.updateCartCount(cart);
    return cart;
  }

  // Cambia una riga del carrello VERO e riallinea pill/contatori.
  // NON renderizza: drawer e pagina carrello aggiornano ognuno la propria vista.
  async function change(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    let cart = await res.json();
    // 422 = quantita' non disponibile (capita di continuo con lo stock a 1):
    // la risposta NON e' un carrello ma {status, message, description}. Senza
    // questo ramo veniva disegnata comunque, e il drawer mostrava totale a zero
    // e righe sparite, come se il carrello si fosse svuotato.
    if (!res.ok) {
      cart = await fetch('/cart.js').then((r) => r.json());
    }
    if (window.OKKO.updateCartCount) window.OKKO.updateCartCount(cart);
    return cart;
  }

  // Apre il drawer con dati freschi. Esposta su window.OKKO: la usa anche
  // okko-cart.js dopo "Aggiungi tutto al carrello" (barra e modale Riepilogo),
  // cosi' l'esito dell'aggiunta si vede subito (richiesta di Nicolas 2026-08-03).
  async function apriDrawer() {
    await refresh();
    ensureDialog().showModal();
    // aggiornaSoglie gira anche dentro render(), ma a dialog CHIUSO le misure
    // sono zero (display:none): la larghezza delle etichette si puo' calcolare
    // solo ora che il pannello e' impaginato.
    if (window.OKKO && window.OKKO.aggiornaSoglie) window.OKKO.aggiornaSoglie();
  }
  window.OKKO = window.OKKO || {};
  window.OKKO.apriDrawer = apriDrawer;

  document.addEventListener('click', async (e) => {
    const apri = e.target.closest('[data-okko-drawer-open]');
    if (apri) {
      if (e.metaKey || e.ctrlKey) return; // aperture in nuova scheda: fallback /cart
      e.preventDefault();
      await apriDrawer();
      return;
    }
    if (!dialog || !dialog.open) return;

    const step = e.target.closest('[data-okko-dr-step]');
    if (step) {
      const input = step.parentElement.querySelector('[data-okko-dr-qty]');
      const nuovo = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.okkoDrStep) * (window.OKKO.passo ? window.OKKO.passo() : 1));
      change(input.dataset.okkoDrQty, nuovo).then(render);
      return;
    }
    const rimuovi = e.target.closest('[data-okko-dr-remove]');
    if (rimuovi) {
      change(rimuovi.dataset.okkoDrRemove, 0).then(render);
      return;
    }
    // Svuota dal drawer: niente reload, si ri-renderizza sullo stato vuoto
    if (e.target.closest('[data-okko-dr-svuota]')) {
      const res = await fetch('/cart/clear.js', { method: 'POST' });
      const cart = await res.json();
      render(cart);
      if (window.OKKO.updateCartCount) window.OKKO.updateCartCount(cart);
    }
  });

  document.addEventListener('change', (e) => {
    if (!dialog || !dialog.open) return;
    if (!e.target.matches('[data-okko-dr-qty]')) return;
    change(e.target.dataset.okkoDrQty, Math.max(0, Number(e.target.value) || 0)).then(render);
  });

  // --- Pagina carrello (sections/cart.liquid) --------------------------------
  // Stesse API del drawer, vista diversa: le righe sono server-rendered e qui
  // si aggiornano solo i numeri (o si tolgono le righe rimosse).

  async function aggiornaPaginaCarrello(cart) {
    const pagina = document.querySelector('[data-okko-cart-pagina]');
    if (!pagina) return;
    if (cart.item_count === 0) {
      // Reload SOLO nella transizione a vuoto (c'erano righe): fa rendere al server
      // lo stato "carrello vuoto". Al LOAD con carrello gia' vuoto non ci sono righe
      // e si esce: ricaricare qui mandava la pagina in un loop infinito di reload
      // (initCart -> item_count 0 -> reload -> initCart -> ...), visto il 2026-07-28.
      if (pagina.querySelector('[data-okko-cart-riga]')) window.location.reload();
      return;
    }
    const money = window.OKKO.money;
    const ui = window.OKKO.ui;
    const { info, total, risparmio: risparmioReale } = await scontaBss(cart);
    const righeListino = []; // {q,p,c} per i totali di listino del riepilogo
    pagina.querySelectorAll('[data-okko-cart-riga]').forEach((riga) => {
      const item = (cart.items || []).find((i) => i.key === riga.dataset.okkoCartRiga);
      if (!item) { riga.remove(); return; }
      const b = info.get(item.key) || {};
      const input = riga.querySelector('[data-okko-cart-qty]');
      if (input) input.value = item.quantity;
      // prezzo unitario: rendi il barrato SOLO se scontato (altrimenti resta la
      // resa server, prezzo netto pieno). Il ricarico/consigliato hanno colonne proprie.
      const prezzo = riga.querySelector('[data-okko-cart-prezzo]');
      if (prezzo && b.scontato) prezzo.innerHTML = ui.prezzoHtml(b.unit, null, b.base);
      const sub = riga.querySelector('[data-okko-cart-sub]');
      if (sub) sub.textContent = money(b.line != null ? b.line : item.final_line_price);
      if (riga.dataset.okkoListino) {
        righeListino.push({
          q: item.quantity,
          p: b.unit != null ? b.unit : item.final_price, // prezzo EFFETTIVO (sconto BSS incluso)
          c: Number(riga.dataset.okkoListino),
        });
      }
    });
    // valore al pubblico + ricarico nel riepilogo (frase discorsiva, come il drawer)
    const listinoEl = pagina.querySelector('[data-okko-cart-listino]');
    if (listinoEl && ui && ui.listinoFraseHtml) {
      const html = ui.listinoFraseHtml(righeListino);
      listinoEl.innerHTML = html;
      listinoEl.hidden = !html;
    }
    const totale = pagina.querySelector('[data-okko-cart-totale]');
    if (totale) totale.textContent = money(total);
    const conteggio = pagina.querySelector('[data-okko-cart-conteggio]');
    if (conteggio) conteggio.textContent = `${cart.item_count} ${cart.item_count === 1 ? (T.articolo || 'articolo') : (T.articoli || 'articoli')}`;
    const risparmio = pagina.querySelector('[data-okko-cart-risparmio]');
    if (risparmio) {
      risparmio.hidden = !(risparmioReale > 0);
      const importo = risparmio.querySelector('[data-okko-cart-risparmio-importo]');
      if (importo) importo.textContent = money(risparmioReale);
    }
  }

  // Click DURANTE il lock BSS: dopo ogni modifica del carrello BSS spegne il
  // checkout (~2s, pointer-events:none) mentre ricalcola gli sconti — e chi
  // apre il drawer subito dopo aver toccato le quantita' clicca proprio li'.
  // Col bottone spento il click atterra sul CONTENITORE: se e' caduto sull'area
  // del bottone, si aspetta lo sblocco e si rigioca il click sul bottone
  // agganciato (lo sconto resta affare dell'interceptor BSS, qui nessun bypass).
  document.addEventListener('click', (e) => {
    const az = e.target.closest('[data-okko-dr-azioni]');
    if (!az) return;
    const btn = az.querySelector('button[name="checkout"]');
    if (!btn || btn.classList.contains('okko-btn--spento')) return;
    if (getComputedStyle(btn).pointerEvents !== 'none') return; // vivo: click gia' gestito
    const r = btn.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
    if (btn.dataset.okkoAttesa) return;
    btn.dataset.okkoAttesa = '1';
    btn.classList.add('okko-btn--attesa');
    const t0 = Date.now();
    const timer = setInterval(() => {
      const vivo = getComputedStyle(btn).pointerEvents !== 'none';
      if (vivo || Date.now() - t0 > 6000) {
        clearInterval(timer);
        delete btn.dataset.okkoAttesa;
        btn.classList.remove('okko-btn--attesa');
        if (vivo) btn.click();
      }
    }, 150);
  });

  document.addEventListener('click', async (e) => {
    const step = e.target.closest('[data-okko-cart-step]');
    if (step) {
      const input = step.parentElement.querySelector('[data-okko-cart-qty]');
      const nuovo = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.okkoCartStep) * (window.OKKO.passo ? window.OKKO.passo() : 1));
      change(input.dataset.okkoCartQty, nuovo).then(aggiornaPaginaCarrello);
      return;
    }
    const rimuovi = e.target.closest('[data-okko-cart-remove]');
    if (rimuovi) {
      change(rimuovi.dataset.okkoCartRemove, 0).then(aggiornaPaginaCarrello);
      return;
    }
    if (e.target.closest('[data-okko-cart-svuota]')) {
      await fetch('/cart/clear.js', { method: 'POST' });
      window.location.reload();
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-okko-cart-qty]')) {
      change(e.target.dataset.okkoCartQty, Math.max(0, Number(e.target.value) || 0)).then(aggiornaPaginaCarrello);
      return;
    }
    // note d'ordine: salvate al change (blur) del textarea
    if (e.target.matches('[data-okko-cart-note]')) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value }),
      });
    }
  });

  // ATC altrove con drawer aperto (raro ma possibile): riallinea le righe
  document.addEventListener('okko:cart:updated', (e) => {
    if (dialog && dialog.open && e.detail) render(e.detail);
  });

  // Pagina carrello: passata iniziale di sconto al load. Le righe sono
  // server-rendered a prezzo pieno; quando il ponte BSS e' pronto si ricalcolano
  // prezzo/subtotali/totale. Se BSS e' assente non parte: resta il prezzo pieno
  // (corretto, coincide col checkout non scontato).
  if (document.querySelector('[data-okko-cart-pagina]')) {
    const initCart = () => fetch('/cart.js').then((r) => r.json()).then(aggiornaPaginaCarrello);
    const bss = window.OKKO && window.OKKO.bss;
    if (bss && bss.pronto) initCart();
    else document.addEventListener('okko:bss:pronto', initCart, { once: true });
  }
})();
